<template>
  <div class="templateOne">
    <title-widge
      :title="data.title"
      :subTitle="data.subTitle"
      :titleColor="titleColor"
      :subTitleColor="subTitleColor"
      :fontBg="fontBg"
      :fontBgColor="fontBgColor"
      :prevImg="prevImg"
      :nextImg="nextImg"
    ></title-widge>
    <div class="divItems">
      <div v-for="(item, index) in data.items" :key="index" class="divItem">
        <img
          v-lazy="{
            src: item.url,
            loading: require('./../../../../../assets/wheelplanting.jpg'),
          }"
        />
        <div>{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import titleWidge from "./../../ai/components/titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    titleColor: {
      type: String,
      default: "rgba(255,255,255,1)",
    },
    subTitleColor: {
      type: String,
      default: "rgba(10,228,242,1)",
    },
    prevImg: {
      type: String,
      default: require("./../../ai/img/title_prev.png"),
    },
    nextImg: {
      type: String,
      default: require("./../../ai/img/title_next.png"),
    },
    fontBg: {
      type: String,
      default: "",
    },
    fontBgColor: {
      type: String,
      default: "rgba(10,226,242,1)",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.templateOne {
  background: rgba(17, 33, 63, 1);
  padding-bottom: 86px;
  padding-top: 86px;
  .divItems {
    display: flex;
    justify-content: center;
    .divItem {
      text-align: center;
      margin-right: 198px;
      &:last-child {
        margin-right: 0;
      }
      img {
        width: 200px;
      }
      div {
        height: 23px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 23px;
        margin-top: 14px;
      }
    }
  }
}
</style>
